import Company from '@queries/Company'
import * as types from '@store/types'
import request from '@queries'

const state = {
  company: {}
}

const getters = {
  [types.COMPANY_PERMISSIONS]: ({ company }) => {
    if (company && company.permissions) {
      const companyPermissionAwards = [
        ...company.permissions
      ]
      return companyPermissionAwards
    }
    return []
  },
  [types.COMPANY]: ({ company }) => company
}

const mutations = {
  [types.COMPANY]: (state, payload) => {
    state.company = { ...payload }
  }
}

const actions = {
  [types.COMPANY]: async ({ commit, getters }) => {
    request(Company).then((response) => {
      if (response.data && response.data.data && response.data.data.company) {
        commit(types.COMPANY, response.data.data.company)
        return response.data.data.company
      }
    }).catch((e) => {
      return {}
    })
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/company.js